import React, { lazy } from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";

const ModelsView = lazy(() =>
  import("../../container/crud/modelsWithManuals/index")
);
const ModelsAdd = lazy(() =>
  import("../../container/crud/modelsWithManuals/Add")
);

const PagesRoute = () => {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route path={`${path}/view`} component={ModelsView} />
      <Route path={`${path}/add`} component={ModelsAdd} />
      <Route path={`${path}/edit/:id`} component={ModelsAdd} />
    </Switch>
  );
};

export default PagesRoute;
